import { AssetRepository } from '@/lib/assets/types'
import { MeilisearchAssetRepository } from '@/lib/assets/repositories/meilisearch-asset-repository'

/**
 * Instantiates the repository for listing assets.
 */
export const forListing = (): AssetRepository => {
  return new MeilisearchAssetRepository()
}

/**
 * Instantiates the repository for details of a single asset.
 */
export const forDetails = (): AssetRepository => {
  return new MeilisearchAssetRepository()
}

/**
 * Instantiates the repository for searching assets.
 */
export const forSearch = (): AssetRepository => {
  return new MeilisearchAssetRepository()
}
